import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import type {Referral, Step, UpdateStep} from "@khan/auth-shared";

import ProgressShellFullLayout from "./progress-shell-full-layout.tsx";
import ProgressShell from "./progress-shell.tsx";

type Props = {
    referral: Referral;
    initialStep: Step;
    detailScreen: (step?: Step) => React.ReactNode;
    actionScreen: (step: Step, updateStep: UpdateStep) => React.ReactNode;
};

// Similar to ProgressShellWithBackground, but removes the background and
// expands the detail & action screens to fill the entire space.
class ProgressShellFull extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <div className={css(styles.progressShellFull)}>
                <ProgressShell
                    {...this.props}
                    customLayoutComponent={ProgressShellFullLayout}
                />
            </div>
        );
    }
}

const styles = StyleSheet.create({
    progressShellFull: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        minHeight: `calc(100vh - 200px)`,
    },
});

export default ProgressShellFull;
